import { render, staticRenderFns } from "./ProductDialog.vue?vue&type=template&id=2b69908a&scoped=true"
import script from "./ProductDialog.vue?vue&type=script&lang=js"
export * from "./ProductDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDialog.vue?vue&type=style&index=0&id=2b69908a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69908a",
  null
  
)

export default component.exports